import {Collection} from "vue-mc"
import clearanceCheckModel from "@/models/clearanceCheckModel"

import Vue from "vue";

export default class clearanceCheckCollection extends Collection {

	model() {
		return clearanceCheckModel;
	}

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'menu',
			checkType: 'WorkingWithChildrenCheck',
			itProjectId: localStorage.getItem('itProjectId'),
			isEndDate: 0,
			data: {},
			dbData: {}
		}
	}

	options() {
		return {
			methods: {
				menu: 'GET',
				list: 'GET',
				child_list: 'GET',
				profile: 'GET',
				categories: 'GET',
				information: 'GET'
			}
		}
	}

	routes() {
		return {
			menu: 'interpreter/clearance_check/menu',
			list: 'interpreter/clearance_check/{checkType}/list/{isEndDate}',
			child_list: 'interpreter/clearance_check/{checkType}/child',
			profile: 'interpreter/clearance_check/profile',
			categories: 'interpreter/clearance_check/categories',
			information: 'interpreter/clearance_check/information/2'
		}
	}

	requestRoute() {

		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.getAttributes().methodTypes);
		let route = this.getAttributes().inBuiltApi + this.getRoute(this.getAttributes().methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.getAttributes().data;

    console.log('TEST', method, route, params, url, data, headers)

		return this.getRequest({headers, method, url, data}).send();
	}

	getMenuList() {
		this.getAttributes().methodTypes = 'menu';
		return this.requestRoute();
	}

	getProfileList() {
		this.getAttributes().methodTypes = 'profile';
		return this.requestRoute();
	}

	getCategoryList() {
		this.getAttributes().methodTypes = 'categories';
		return this.requestRoute();
	}

	getInformation() {
		this.getAttributes().methodTypes = 'information';
		return this.requestRoute();
	}

	getList(checkType, isEndDate) {
		this.getAttributes().methodTypes = 'list';
		this.getAttributes().checkType = checkType;
		this.getAttributes().isEndDate = isEndDate;
		return this.requestRoute();
	}

	getChildList(checkType) {
		this.getAttributes().methodTypes = 'child_list';
		this.getAttributes().checkType = checkType;
		return this.requestRoute();
	}
}
